import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './core/components/system/nofound/notfound.component';

/**
 * Note: Here it maintains all route entries to other modules.
 * It is the start entry for whole application.
 */
const sjiRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: './home/home.module#HomeModule'
  },
  {
    path: 'user',
    loadChildren: './user/user.module#UserModule'
  },
  {
    path: 'company',
    loadChildren: './company/company.module#CompanyModule'
  },
  {
    path: 'customer',
    loadChildren: './customer/customer.module#CustomerModule'
  },
  {
    path: 'order',
    loadChildren: './order/order.module#OrderModule'
  },
  {
    path: 'tracking',
    loadChildren: './tracking/tracking.module#TrackingModule'
  },
  {
    path: 'vendor',
    loadChildren: './vendor/vendor.module#VendorModule'
  },
  // {
  //   /** Corporate with getOidcClientSettings method and SecurityOidcService. Identity Server integration need. Don't move it. */
  //   path: 'auth-callback',
  //   component: AuthCallbackComponent
  // },
  // {
  //   /** Corporate with getOidcClientSettings method and SecurityOidcService. Identity Server integration need. Don't move it. */
  //   path: 'silent-refresh',
  //   component: SilentRefreshComponent
  // },
  {
    path: '**',
    component: NotFoundComponent
  }
];

/**
 * Note: Here it maintains all route entries to other modules.
 * It is the start entry for whole application.
 */
@NgModule({
  imports: [RouterModule.forRoot(sjiRoutes)],
  exports: [RouterModule]
})
export class SJIRoutingModule { }
